import { getStatusBadge } from "@/components/table-utils/get-status-badge";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import AvatarCard from "@/ui/avatar-card";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Badge, Checkbox, Flex } from "rizzui";
import { User } from "@/types";
import UserForm from "../create-user";
import ModalButton from "../../modal-button";
import CreateEditRole from "../create-role";
import UserCog from "@/components/icons/user-cog";

const columnHelper = createColumnHelper<User>();

export const usersColumns = [
    columnHelper.display({
        id: "select",
        size: 50,
        header: ({ table }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select all Rows"
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => table.toggleAllPageRowsSelected()}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select Row"
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        ),
    }),
    columnHelper.display({
        id: "id",
        size: 100,
        header: "User ID",
        cell: ({ row }) => <>#{row.original.id}</>,
    }),
    columnHelper.accessor("fullname", {
        id: "fullname",
        size: 300,
        header: "Name",
        enableSorting: false,
        cell: ({ row }) => (
            <AvatarCard
                src={""}
                name={row.original.fullname}
                description={row.original.email}
            />
        ),
    }),
    columnHelper.accessor("email", {
        id: "email",
        size: 150,
        header: "Email",
        cell: ({ row }) => row.original.email,
    }),
    columnHelper.accessor("createdDate", {
        id: "createdDate",
        size: 200,
        header: "Created",
        cell: ({ row }) => <DateCell date={new Date(row.original.createdDate)} />,
    }),
    columnHelper.accessor("phoneNumber", {
        id: "phoneNumber",
        size: 150,
        header: "Phone",
        enableSorting: false,
        cell: ({ row }) => row.original.phoneNumber,
    }),
    columnHelper.accessor("isPhoneNumberConfirmed", {
        id: "isPhoneNumberConfirmed",
        size: 150,
        header: "Phone Confirmed",
        cell: ({ row }) => (
            <Flex align="center">
                {row.original.isPhoneNumberConfirmed ? (
                    <Badge variant="solid">Confirmed</Badge>
                ) : (
                    <Badge variant="outline">Not Confirmed</Badge>
                )}
            </Flex>
        ),
    }),
    columnHelper.display({
        id: "action",
        size: 140,
        cell: ({
            row,
            table: {
                options: { meta },
            },
        }) => (
            <ModalButton
                label="Edit"
                icon={<UserCog className="h-5 w-5" />}
                size="sm"
                variant="outline"                
                view={
                    <UserForm
                        title="Edit"
                        register={{
                            title: row.original.fullname,
                            fullName: row.original.fullname,
                            email: row.original.email,
                            mobile: row.original.phoneNumber,
                            password: row.original.password,
                            confirmPassword: row.original.password,
                        }}
                    />
                }
            />
        ),
    }),
];
